export default __webpack_public_path__ + "static/media/ic_my_location.03a3e99f.svg";